// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Q3ebh","logo":"Header_logo__U23op","navBox":"Header_navBox__FzI2f","cartBox":"Header_cartBox__sAb1j","avatar":"Header_avatar__OzU0d"};